import React from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import theme from 'services/theme.semantic';

const BarVertical = ({
  isActive, shouldAnimate, activeColor, isHover,
}) => (
  <Wrapper>
    <BarVerticalStyled
      isActive={isActive}
      shouldAnimate={shouldAnimate}
      activeColor={activeColor}
      isHover={isHover}
    />
  </Wrapper>
);

const Wrapper = styled.div`
  height: 36px;
  display: flex;
  align-items: center;
  margin-top: ${props => props.theme.spacing.xs};
`;

const BarVerticalStyled = styled.div`
  width: 4px;
  height: ${({ isActive, shouldAnimate }) => (isActive || !shouldAnimate ? '36px' : '8px')};
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  background-color: ${({
    isActive, theme, activeColor, isHover,
  }) => (isActive || isHover ? activeColor : theme.colors.bgLighterS)};
  transition: height 0.3s ease-out;
`;

BarVertical.propTypes = {
  isActive: PropTypes.bool,
  shouldAnimate: PropTypes.bool,
  activeColor: PropTypes.string,
  isHover: PropTypes.bool,
};

BarVertical.defaultProps = {
  isActive: false,
  shouldAnimate: true,
  activeColor: theme.colors.primary,
  isHover: false,
};

export default BarVertical;
